import { types } from '../../../constants/ActionTypes'
import { deepCopy } from '../../../lib'
import { LANGUAGE_SHORT_CODE } from '../../../constants';

const initialState = {
  openConfirmDialog: false,
  tabId: 0,
}

const liveGame = (state = initialState, action) => {
  var newState = deepCopy(state)
  if (action.liveId && !newState[action.liveId] ) {
    newState[action.liveId] = {
      userType: '',
      liveStatus: 0,
      boardContext: {},
      chatMessage: {},
    }
  }
  switch (action.type) {
    case types.router.LOCATION_CHANGE:
      let params = action.payload.location.pathname.split('/')
      let regstr = Object.keys(LANGUAGE_SHORT_CODE).map(key => `^${LANGUAGE_SHORT_CODE[key]}$`).join('|')
      let pathname
      if (null !== params[1].match(`/${regstr}/`)) {
        params.splice(1,1)
        pathname = params.join('/')
      }
      else {
        pathname = action.payload.location.pathname
      }
      if (pathname === state.pathname) {
        return state
      }
      else {
        return { ...initialState, pathname }
      }
    case types.live.INITIALIZE:
      return { ...initialState }
    case types.live.RECEIVE_LIVE_STATUS:
      newState[action.liveId].liveStatus = parseInt(action.status, 10)
      return newState
    case types.live.RECEIVE_USER_TYPE:
      newState[action.liveId].userType = action.userType
      return newState
    case types.live.RECEIVE_LATEST_BOARD_CONTEXT:
      newState[action.liveId].boardContext = { isReceived: true }
      return newState
    case types.live.RECEIVE_ALL_CHAT_MESSAGE:
      newState[action.liveId].chatMessage = { isReceived: true }
      return newState
    case types.liveGame.OPEN_CONFIRM_DIALOG:
      return {...state, openConfirmDialog: true}
    case types.liveGame.CLOSE_CONFIRM_DIALOG:
      return {...state, openConfirmDialog: false}
    case types.liveGame.CHANGE_TAB:
      return {...state, tabId: action.tabId }
    case types.renjuBoardCard.CLOSE:
      return {...state, tabId: state.tabId - 1}
    default:
      return state
  }
}

export default liveGame


// WEBPACK FOOTER //
// ./src/reducers/Page/Live/LiveGame.js